exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* You can add global styles to this file, and also import other style files */\r\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/css-loader?{"sourceMap":false,"importLoaders":1}!C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/~/postcss-loader?{"ident":"postcss"}!C:/Users/oggy.yuristantyo/source/Workspaces/UI_SBN_Ritel_Web/src/styles.css
// module id = ../../../../css-loader/index.js?{"sourceMap":false,"importLoaders":1}!../../../../postcss-loader/index.js?{"ident":"postcss"}!../../../../../src/styles.css
// module chunks = 2